import React from 'react';

const StateContext = React.createContext();

export function useStateContext() {
	return React.useContext(StateContext);
}

export default StateContext;
